import { IShowable } from "../interfaces/IShowable";
import { IToggle } from "../interfaces/IToggle";
import { TextureStatesData } from "../types/types";

/**
 * links specific child view to it's state texture definitions
 */
// export type UpdateToggleableViewDef = {
//     view: Phaser.GameObjects.Image | Phaser.GameObjects.Text;
//     textureData?: {
//         selected?: TextureStatesData;
//     },
//     textStyle?: {
//         deselected?: Phaser.Types.GameObjects.Text.TextStyle;
//         selected?: Phaser.Types.GameObjects.Text.TextStyle;
//     },
// }

export class Toggleable 
    extends Phaser.GameObjects.Container
    implements IToggle
{
    /**
     * Flag that reports whether button is selected or not selected
     */
    protected isSelected: boolean;
    /**
     * Child views whos view changes based on the toggle state of parent 
     * (that this Mixin was mixed into)
     * NOTE: this does not affect individual view's interactivity, 
     *       by default we should prob just use parent registration
     *       to avoid confusion of individual viwes being selected/deselected 
     *       (which they are not; only visually and all at once)
     */
    // protected updateToggleableViews: UpdateToggleableViewDef[];
    

    // public AddToggleableViewDef(def: UpdateToggleableViewDef) {
    //     if (this.updateToggleableViews == undefined) {
    //         this.updateToggleableViews = [];
    //     }
    //     this.updateToggleableViews.push(def);
    // }
    
    /**
    * Select toggle is not yet selected
    * @param selected 
    * @param force force flag set and view update even if equal 
    *              (normally dont need to do this, except in cases like first init)
    * @returns this, for chaining
    */
   public SetSelected(selected: boolean, force: boolean = false): void
   {
    //    console.log("Toggle::SetSelected", selected, this.isSelected)

       if ((this.isSelected != selected) || force) {
           // toggle selection, enable/disable etc
           this.isSelected = selected;
   
            // in sub or another mixin
            // ex: update view
            // @ts-ignore
            if (this.UpdateViewFromSelected != undefined) {
                // @ts-ignore
                this.UpdateViewFromSelected(this.isSelected);
            }
       }
   }

   public IsSelected(): boolean
   {
       return this.isSelected;
   }

   public Toggle(): void
   {
       this.SetSelected(!this.isSelected);
   }
}